// import React from 'react';
// import { FileText } from 'lucide-react';
// import styles from '../StudyManagement.module.css';

// const EnrollmentCards = ({ subjects, studyData, userSite }) => {
//     return (
//         <div className={styles.cardsSection}>
//             {/* First Row - Full Width Card */}
//             {/* <div className={styles.fullWidthCardRow}>
//                 <div className={styles.infoCard}>
//                     <div className={styles.infoCardLabel}>
//                         <FileText size={16} />
//                         <span>Your Site Status</span>
//                     </div>

//                     {userSite ? (
//                         <div className={styles.topSiteEnrollment}>
//                             <div className={styles.enrollmentInfo}>
//                                 <p className={styles.enrollmentDetail} style={{ fontWeight: 600, color: '#111827', marginBottom: '8px' }}>
//                                     {userSite.code} - {userSite.name}
//                                 </p>
//                                 <p className={styles.enrollmentDetail}>
//                                     {userSite.enrolled} of {userSite.maxEnrollment} subjects enrolled
//                                 </p>
//                                 <div className={styles.progressBar}>
//                                     <div
//                                         className={styles.progressFill}
//                                         style={{ width: `${userSite.progress}%` }}
//                                     ></div>
//                                 </div>
//                                 <p className={styles.enrollmentStatusText}>
//                                     {userSite.enrolled < userSite.maxEnrollment ? (
//                                         <span className={styles.greenText}>
//                                             ✓ {userSite.maxEnrollment - userSite.enrolled} slot{userSite.maxEnrollment - userSite.enrolled !== 1 ? 's' : ''} remaining
//                                         </span>
//                                     ) : (
//                                         <span className={styles.redText}>
//                                             ✕ Limit reached
//                                         </span>
//                                     )}
//                                 </p>
//                             </div>
//                         </div>
//                     ) : (
//                         <div className={styles.noSiteSelected}>No site assigned</div>
//                     )}
//                 </div>
//             </div> */}

//             {/* Second Row - Three Cards */}
//             <div className={styles.infoCards}>
//                 {/* Total Enrollments Card */}
//                 <div className={styles.infoCard}>
//                     <div className={styles.infoCardLabel}>
//                         <FileText size={16} />
//                         <span>Total Enrollments</span>
//                     </div>
//                     <div className={styles.infoCardValue}>{studyData.totalEnrolments}</div>
//                     <div className={styles.infoCardSubValue}>All Subjects</div>
//                 </div>

//                 {/* Drafts Card */}
//                 <div className={styles.infoCard}>
//                     <div className={styles.infoCardLabel}>
//                         <FileText size={16} />
//                         <span>Drafts</span>
//                     </div>
//                     <div className={styles.infoCardValue}>{studyData.drafts}</div>
//                     <div className={styles.infoCardSubValue}>In Progress</div>
//                 </div>

//                 {/* Completed Card */}
//                 <div className={styles.infoCard}>
//                     <div className={styles.infoCardLabel}>
//                         <FileText size={16} />
//                         <span>Completed</span>
//                     </div>
//                     <div className={styles.infoCardValue}>{studyData.completed}</div>
//                     <div className={styles.infoCardSubValue}>Finished Forms</div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EnrollmentCards;

import React from 'react';
import { FiFileText, FiCheckCircle, FiEdit3 } from 'react-icons/fi';
import styles from '../StudyManagement.module.css';

const iconMap = {
    'Total Enrollments': FiFileText,
    'Drafts': FiEdit3,
    'Completed': FiCheckCircle
};

const colorMap = {
    'Total Enrollments': '#3b82f6', // blue
    'Drafts': '#f59e0b', // amber
    'Completed': '#10b981' // green
};

const StatCard = ({ title, value, subValue }) => {
    const Icon = iconMap[title];
    const color = colorMap[title];

    return (
        <div className={styles.statCard}>
            <div className={styles.statIcon} style={{ backgroundColor: `${color}15`, color: color }}>
                <Icon />
            </div>
            <div className={styles.statContent}>
                <h3 className={styles.statTitle}>{title}</h3>
                <p className={styles.statValue}>{value}</p>
                {subValue && <p className={styles.statSubValue}>{subValue}</p>}
            </div>
        </div>
    );
};

const EnrollmentCards = ({ subjects, studyData, userSite }) => {
    const stats = [
        {
            title: 'Total Enrollments',
            value: studyData.totalEnrolments,
            subValue: 'All Subjects'
        },
        {
            title: 'Drafts',
            value: studyData.drafts,
            subValue: 'In Progress'
        },
        {
            title: 'Completed',
            value: studyData.completed,
            subValue: 'Finished Forms'
        }
    ];

    return (
        <div className={styles.cardsSection}>
            <div className={styles.statsGrid}>
                {stats.map((stat, index) => (
                    <StatCard
                        key={index}
                        title={stat.title}
                        value={stat.value}
                        subValue={stat.subValue}
                    />
                ))}
            </div>
        </div>
    );
};

export default EnrollmentCards;